import classNames from "classnames";
import { useField } from "formik";
import { useTranslation } from "react-i18next";
import { FormGroup, Input, Label } from "reactstrap";

import ErrorMessageDefault from "../base/components/ErrorMessageDefault";

const CheckboxControl = ({
  id,
  name,
  children,
  disabled,
  className,
  wrapperClassName,
  contentClassName,
  errorClassName,
}) => {
  const { t } = useTranslation("errors");
  const [{ checked, onChange }, meta, { setTouched }] = useField({
    name,
    type: "checkbox",
  });

  const handlechange = (event) => {
    setTouched();
    onChange(event);
  };

  return (
    <section className={classNames("form-control-wrapper", wrapperClassName)}>
      <FormGroup
        className={classNames("d-flex align-items-center", contentClassName)}
        check
      >
        <Input
          checked={checked}
          id={id || name}
          color="primary"
          name={name}
          type="checkbox"
          disabled={disabled}
          onChange={handlechange}
          className={classNames(
            className,
            "cursor-pointer flex-shrink-0 rounded-extra-small",
          )}
        />
        <Label disabled={disabled} htmlFor={name} check>
          {children}
        </Label>
      </FormGroup>
      {meta.touched && (
        <ErrorMessageDefault
          className={classNames(
            errorClassName,
            "position-absolute bottom-0 mt-0",
          )}
          name={name}
        >
          {t(meta.error)}
        </ErrorMessageDefault>
      )}
    </section>
  );
};

export default CheckboxControl;
